import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import pdf from "../../Assets/MERN-STACK-DEVELOPER.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function Resume() {
 
  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Frontend Developer"
              // date="July 2021 - September 2021"
              content={[
                "Worked on the development of a ticketing website.",
                "Built a real time voting app using Mongodb, Express, React js, Node js and socket io.",
                "Designed an oil and gas website using figma and translated it into a highly responsive user interface using html, css and javascript.",
                "Also developed an online investment platform.",
              ]}
            />
           
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="Studied Statistics [Ken Saro-Wiwa Polytechnic, Rivers State] "
              // date="2018 - Present"
              content={[`CGPA:  3.52`]}
            />

            <h3 className="resume-title">Publications</h3>
            <Resumecontent
              title=""
              content={[
                "Time Series Analysis of Fire Outbreak in Port Harcourt using ARIMA MODEL.",
              ]}
            />

          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
